<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Chiller Sequencing Profile - DTchw
                    <v-spacer></v-spacer>
                    <date-range-selector v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <vue-plotly v-if="data1" disable-responsive :data="data1" :layout="layout1" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from 'moment'
    import {callAPI} from '@/helper'
    import VuePlotly from "../components/VuePlotly";
    import DateRangeSelector from "../components/DateRangeSelector";
    import smoothLine from "../components/mixins/smoothLine";
    export default {
        name: 'HKLEnergy',
        components: {VuePlotly,DateRangeSelector},
        mixins:[smoothLine],
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(31, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(1, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                loading:true,
                data1:null,
                layout1:{
                    title:"Chiller Sequencing Profile - DTchw",
                    yaxis: {
                        title: 'Temperature Δ (°C) '
                    },
                    xaxis: {
                        title: 'Building Cooling Load (kW)'
                    }
                },

            }
        },

        methods:{
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let chillers=[]
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                        let allSensors=this.$store.state.pointsListStore.pointsList.sensors[i]
                        if(allSensors.indexOf("Cooling_Load")>-1){
                            chillers.push(equip.equipment_name)
                        }
                    }
                }
                callAPI('stagingprofile/',{
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:currentRange,
                    equipment_names:chillers,
                    'extra_vars': [{
                        'equipment_name': 'Chilled_Water_Header',
                        'sensor_names': ['Header_Chilled_Water_Delta_T']
                    }]
                }).then(function(result){
                    let data1=[]
                    let m=0
                    let options = {span: 0.6, band: 0.8, degree: 1}
                    let colorList = ['#1f77b4',  // muted blue
                        '#ff7f0e',  // safety orange
                        '#2ca02c',  // cooked asparagus green
                        '#d62728',  // brick red
                        '#9467bd',  // muted purple
                        '#8c564b',  // chestnut brown
                        '#e377c2',  // raspberry yogurt pink
                        '#7f7f7f',  // middle gray
                        '#bcbd22',  // curry yellow-green
                        '#17becf']
                    for (let index in result.data.result){
                        let x=result.data.result[index].Cooling_Load
                        let y=result.data.result[index]['Header_Chilled_Water_Delta_T']
                        if(x&&x.length>10&&y&&y.length>10){
                            data1.push({
                                name:index,
                                x:x,
                                y:y,
                                mode:'markers',
                                marker: {
                                    color: colorList[m % 10]
                                },
                            })
                            let cleanedX=[]
                            let cleanedY=[]
                            for(let i in x){
                                if(x[i]>0&&y[i]>0){
                                    cleanedX.push(x[i])
                                    cleanedY.push(y[i])
                                }
                            }

                            let smooth = me.smoothLineLoess(cleanedX, cleanedY, 50, options)
                            data1.push({
                                line: {
                                    color: colorList[m % 10]
                                },
                                x: smooth.data['x'],
                                y: smooth.fitted['fitted'],
                                mode: 'lines',
                                name: 'Smoothed Line of ' + index,
                            })
                            m++
                        }


                    }
                    me.data1=data1
                    me.loading=false
                })


            }

        },
        beforeMount() {
            let preconf={...this.$route.query}
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(preconf.rangeStart&&preconf.rangeEnd){
                this.baseDate=moment(preconf.rangeStart)
                this.endDate=moment(preconf.rangeEnd)
                this.dateRange={start:preconf.rangeStart,end:preconf.rangeEnd}
            } else if(maxDate){
                this.baseDate=moment(maxDate).subtract(31, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }



    }
</script>
